if (!customElements.get("quizz-modale")) {
  customElements.define(
    "quizz-modale",
    class QuizzModale extends HTMLElement {
      constructor() {
        super();
        this.details = this.querySelector("details");
        this.closeButtons = this.querySelectorAll("[data-quizz-close]");
        this.overlay = this.querySelector(".quizz-modale__overlay");
        this.nextButton = this.querySelector("[data-quizz-next]");
        this.previousButton = this.querySelector("[data-quizz-previous]");
        this.finishButton = this.querySelector("[data-quizz-finish]");
        this.nextToBudgetButtons = this.querySelectorAll(
          "[data-quizz-next-to-budget]",
        );
        this.completeButton = this.querySelector("[data-quizz-complete]");
        this.restartButtons = this.querySelectorAll("[data-quizz-restart]");
        this.emailInput = this.querySelector("[data-quiz-email]");
        this.newsletterForm = this.querySelector("#newsletter-quiz");
        this.newsletterBlock = this.querySelector(".quizz-modale__newsletter");
        this.submitButton = this.querySelector("[data-quiz-submit]");
        this.steps = this.querySelectorAll(".quizz-modale__step");
        this.productsSlider = this.querySelector("#QuizProductsSlider");
        this.productsSourceUrl =
          this.productsSlider?.dataset.productsSource ||
          "/collections/matcha-bio";
        this.klaviyoCompanyId =
          window.quizzModaleData?.klaviyoCompanyId || "xABwcy";
        this.klaviyoListId = window.quizzModaleData?.klaviyoListId || "Rd2xrA";
        this.quizStartTracked = false;
        this.currentStep = 1;
        this.flickitySlider = null;
        this.isCustomerLoggedIn =
          window.quizzModaleData?.isCustomerLoggedIn || false;
        this.customerEmail = window.quizzModaleData?.customerEmail || "";

        this.setupEventListeners();
        this.validateCompleteButton();
        this.handleLoggedInCustomer();
        this.checkURLHash();
      }

      /**
       * Vérifie le hash d'URL et ouvre la modale si #quizz est présent
       */
      checkURLHash() {
        try {
          if (window.location.hash === "#quizz") {
            this.open();
          }
        } catch (error) {
          console.error("Erreur lors de la vérification du hash d'URL:", error);
        }
      }

      /**
       * Ouvre la modale du quiz avec animation
       */
      open() {
        if (this.details) {
          this.trackQuizStart();

          // Ajouter l'attribut open sans animation d'abord
          this.details.setAttribute("open", "");
          document.body.classList.add("scroll-lock");

          // Petite temporisation pour permettre au DOM de se mettre à jour
          // et à l'animation CSS de se déclencher correctement
          requestAnimationFrame(() => {
            const container = this.querySelector(".quizz-modale__container");
            if (container) {
              container.style.transform = "translateX(0)";
            }
          });
        }
      }

      setupEventListeners() {
        // Écouter l'événement toggle du details pour gérer l'animation
        if (this.details) {
          this.details.addEventListener("toggle", () => {
            if (this.details.hasAttribute("open")) {
              // La modale s'ouvre
              this.open();
            }
          });
        }

        // Écouter les changements dans le champ email
        if (this.emailInput) {
          this.emailInput.addEventListener(
            "input",
            this.validateCompleteButton.bind(this),
          );
          this.emailInput.addEventListener(
            "blur",
            this.validateCompleteButton.bind(this),
          );
        }

        // Intercepter la soumission du formulaire newsletter
        if (this.newsletterForm) {
          this.newsletterForm.addEventListener("submit", (e) => {
            e.preventDefault();
            this.handleNewsletterSubmit();
          });
        }
        this.closeButtons.forEach((button) => {
          button.addEventListener("click", (e) => {
            e.preventDefault();
            this.close();
          });
        });

        if (this.overlay) {
          this.overlay.addEventListener("click", (e) => {
            if (e.target === this.overlay) {
              this.close();
            }
          });
        }

        // Options pour chaque étape
        this.steps.forEach((step) => {
          const options = step.querySelectorAll(".quizz-modale__option");
          options.forEach((option) => {
            option.addEventListener("click", () => {
              this.selectOption(option, step);
            });
          });
        });

        if (this.nextButton) {
          this.nextButton.addEventListener("click", () => {
            this.nextStep();
          });
        }

        // Gérer tous les boutons précédent (pas seulement le premier)
        const previousButtons = this.querySelectorAll("[data-quizz-previous]");
        previousButtons.forEach((button) => {
          button.addEventListener("click", () => {
            this.previousStep();
          });
        });

        if (this.finishButton) {
          this.finishButton.addEventListener("click", () => {
            this.finishQuiz();
          });
        }

        this.nextToBudgetButtons.forEach((button) => {
          button.addEventListener("click", () => {
            this.goToBudgetStep();
          });
        });

        if (this.completeButton) {
          this.completeButton.addEventListener("click", () => {
            this.completeQuiz();
          });
        }

        if (this.restartButtons) {
          this.restartButtons.forEach((button) => {
            button.addEventListener("click", () => {
              this.restartQuiz();
            });
          });
        }

        document.addEventListener("keydown", (e) => {
          if (e.key === "Escape" && this.details.hasAttribute("open")) {
            this.close();
          }
        });
      }

      selectOption(selectedOption, step) {
        const options = step.querySelectorAll(".quizz-modale__option");
        options.forEach((option) => {
          option.classList.remove("quizz-modale__option--selected");
        });
        selectedOption.classList.add("quizz-modale__option--selected");
      }

      nextStep() {
        const currentStepElement = this.querySelector(
          `[data-step="${this.currentStep}"]`,
        );
        const selectedOption = currentStepElement.querySelector(
          ".quizz-modale__option--selected",
        );

        if (selectedOption && selectedOption.dataset.option === "oui") {
          this.currentStep = 2;
          this.showStep(this.currentStep);
        } else if (selectedOption && selectedOption.dataset.option === "non") {
          this.currentStep = 3;
          this.showStep(this.currentStep);
        }
      }

      previousStep() {
        if (this.currentStep > 1) {
          if (this.currentStep === 5) {
            // Depuis l'étape finale (5), retour vers l'étape budget (4)
            this.currentStep = 4;
          } else if (this.currentStep === 4) {
            // Depuis l'étape budget (4), déterminer quelle était l'étape précédente (2 ou 3)
            const step1 = this.querySelector('[data-step="1"]');
            const step1Option = step1.querySelector(
              ".quizz-modale__option--selected",
            );
            if (step1Option && step1Option.dataset.option === "oui") {
              this.currentStep = 2; // Retour vers étape 2 (moment matcha)
            } else {
              this.currentStep = 3; // Retour vers étape 3 (gamme)
            }
          } else if (this.currentStep === 3) {
            // Depuis l'étape 3 (NON), retour vers l'étape 1
            this.currentStep = 1;
          } else if (this.currentStep === 2) {
            // Depuis l'étape 2 (OUI), retour vers l'étape 1
            this.currentStep = 1;
          } else {
            // Pour les autres cas, retour normal
            this.currentStep--;
          }
          this.showStep(this.currentStep);
        }
      }

      showStep(stepNumber) {
        this.steps.forEach((step) => {
          step.classList.remove("quizz-modale__step--active");
        });

        const targetStep = this.querySelector(`[data-step="${stepNumber}"]`);
        if (targetStep) {
          targetStep.classList.add("quizz-modale__step--active");
        }
      }

      finishQuiz() {
        // Depuis l'étape budget (4), aller à l'étape finale (newsletter)
        this.currentStep = 5;
        this.showStep(this.currentStep);
        this.pushQuizEvent("quiz_complete", this.getQuizData());

        // Charger les produits filtrés
        this.loadFilteredProducts();

        // Si le client est connecté, valider automatiquement
        if (this.isCustomerLoggedIn) {
          setTimeout(() => {
            this.handleNewsletterSubmit();
          }, 1000);
        }
      }

      handleLoggedInCustomer() {
        if (this.isCustomerLoggedIn && this.newsletterBlock) {
          // Masquer le bloc newsletter si le client est connecté
          this.newsletterBlock.style.display = "none";
        }
      }

      async handleNewsletterSubmit() {
        if (!this.submitButton) {
          console.warn("⚠️ Quiz Modal - Bouton de soumission introuvable");
          return;
        }

        const email = this.emailInput
          ? this.emailInput.value.trim()
          : this.customerEmail;

        // Vérifier que l'email est valide
        if (
          !email ||
          (!this.isCustomerLoggedIn && !this.isValidEmailFormat(email))
        ) {
          console.warn("⚠️ Quiz Modal - Email invalide ou manquant");
          if (this.emailInput) {
            this.emailInput.focus();
          }
          return;
        }

        // Changer l'état du bouton en loading
        this.setSubmitButtonState("loading");

        try {
          // Récupérer les données du quiz
          const quizData = this.getQuizData();

          this.pushQuizEvent("quiz_newsletter_submit", quizData);

          try {
            await this.sendToKlaviyo(email, quizData);
          } catch (error) {
            console.warn("⚠️ Quiz Modal - Klaviyo subscribe failed:", error);
          }

          // Ajouter les données du quiz au formulaire
          this.addQuizDataToForm(quizData);

          // Soumettre le formulaire Shopify
          await this.submitFormInIframe();

          // Changer l'état du bouton en success
          this.setSubmitButtonState("success");
          this.pushQuizEvent("quiz_newsletter_success", quizData);

          // Attendre un peu puis faire le fadeOut
          setTimeout(() => {
            this.fadeOutNewsletter();
          }, 1500);
        } catch (error) {
          console.error("❌ Quiz Modal - Erreur lors de la soumission:", error);
          // Remettre le bouton en état normal en cas d'erreur
          this.setSubmitButtonState("normal");
        }
      }

      setSubmitButtonState(state) {
        if (!this.submitButton) return;

        const arrowIcon = this.submitButton.querySelector(
          ".quizz-modale__submit-icon--arrow",
        );
        const checkIcon = this.submitButton.querySelector(
          ".quizz-modale__submit-icon--check",
        );

        // Reset tous les états
        this.submitButton.classList.remove("btn--loading");
        if (arrowIcon) arrowIcon.style.display = "block";
        if (checkIcon) checkIcon.style.display = "none";

        switch (state) {
          case "loading":
            this.submitButton.classList.add("btn--loading");
            if (arrowIcon) arrowIcon.style.display = "none";
            break;
          case "success":
            this.submitButton.classList.remove("btn--loading");
            if (arrowIcon) arrowIcon.style.display = "none";
            if (checkIcon) checkIcon.style.display = "block";
            break;
          case "normal":
          default:
            // État par défaut déjà appliqué
            break;
        }
      }

      async sendToKlaviyo(email, quizData) {
        // Mapper les valeurs du quiz vers les propriétés Klaviyo
        const quizContext = this.getQuizContext();
        const klaviyoProperties = {
          "Gamme de matcha": this.getGammeLabel(quizData.step2or3),
          "Usage du matcha": this.getUsageLabel(quizData.step2or3),
          "Tranche de prix": this.getBudgetLabel(quizData.budget),
          quiz_step1: quizData.step1 || "",
          quiz_choice: quizData.step2or3 || "",
          quiz_budget: quizData.budget || "",
          quiz_context: quizContext.quiz_context,
          page_path: quizContext.page_path,
        };

        // Enrichir le profil si le script onsite Klaviyo est disponible.
        if (window._klOnsite) {
          window._klOnsite.push(["identify", { email, ...klaviyoProperties }]);
        } else {
          console.warn(
            "⚠️ Quiz Modal - Klaviyo non disponible (window._klOnsite introuvable)",
          );
        }

        if (!window.fetch || !this.klaviyoCompanyId || !this.klaviyoListId) {
          return;
        }

        const response = await fetch(
          `https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(
            this.klaviyoCompanyId,
          )}`,
          {
            method: "POST",
            headers: {
              accept: "application/vnd.api+json",
              "content-type": "application/vnd.api+json",
              revision: "2026-04-15",
            },
            body: JSON.stringify({
              data: {
                type: "subscription",
                attributes: {
                  custom_source: "Quiz matcha",
                  profile: {
                    data: {
                      type: "profile",
                      attributes: {
                        email,
                        subscriptions: {
                          email: {
                            marketing: {
                              consent: "SUBSCRIBED",
                            },
                          },
                        },
                        properties: klaviyoProperties,
                      },
                    },
                  },
                },
                relationships: {
                  list: {
                    data: {
                      type: "list",
                      id: this.klaviyoListId,
                    },
                  },
                },
              },
            }),
          },
        );

        if (!response.ok) {
          throw new Error(`Klaviyo subscribe failed: ${response.status}`);
        }
      }

      getQuizContext() {
        const path = window.location.pathname;

        return {
          quiz_context: this.closest("[data-blog-attribution-root]")
            ? "blog_article"
            : path.indexOf("/collections/") === 0
              ? "collection"
              : "site",
          page_path: path,
        };
      }

      trackQuizStart() {
        if (this.quizStartTracked) return;
        this.quizStartTracked = true;
        this.pushQuizEvent("quiz_start", this.getQuizData());
      }

      pushQuizEvent(eventName, quizData) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: eventName,
          ...this.getQuizContext(),
          quiz_step1: quizData.step1 || "",
          quiz_choice: quizData.step2or3 || "",
          quiz_budget: quizData.budget || "",
          quiz_email_present: Boolean(quizData.email),
        });
      }

      getGammeLabel(choice) {
        const mapping = {
          quotidien: "Quotidien & accessible",
          premium: "Premium & Raffiné",
          prestigieux: "Prestigieux & Exceptionnel",
        };
        return mapping[choice] || "";
      }

      getUsageLabel(choice) {
        const mapping = {
          degustation: "Dégustation",
          latte: "Quotidien",
          cadeau: "Cadeau",
        };
        return mapping[choice] || "";
      }

      getBudgetLabel(budget) {
        const mapping = {
          "budget-25-50": "25€ - 50€",
          "budget-50-100": "50€ - 100€",
          "budget-100-200": "100€ - 200€",
        };
        return mapping[budget] || "";
      }

      fadeOutNewsletter() {
        if (this.newsletterBlock) {
          this.newsletterBlock.style.transition =
            "opacity 0.5s ease, height 0.5s ease";
          this.newsletterBlock.style.opacity = "0";
          this.newsletterBlock.style.height = "0";
          this.newsletterBlock.style.overflow = "hidden";

          setTimeout(() => {
            this.newsletterBlock.style.display = "none";
          }, 500);
        }
      }

      async submitFormInIframe() {
        return new Promise((resolve, reject) => {
          // Créer un iframe caché pour la soumission
          const iframe = document.createElement("iframe");
          iframe.style.display = "none";
          iframe.name = "newsletter-submit-quiz";
          document.body.appendChild(iframe);

          // Sauvegarder le target original
          const originalTarget = this.newsletterForm.target;

          // Modifier le target du formulaire vers l'iframe
          this.newsletterForm.target = "newsletter-submit-quiz";

          // Écouter le chargement de l'iframe
          iframe.onload = () => {
            resolve();
            // Nettoyer après la soumission
            setTimeout(() => {
              if (iframe.parentNode) {
                document.body.removeChild(iframe);
              }
              // Restaurer le target original
              if (originalTarget) {
                this.newsletterForm.target = originalTarget;
              } else {
                this.newsletterForm.removeAttribute("target");
              }
            }, 1000);
          };

          iframe.onerror = () => {
            reject(new Error("Erreur lors de la soumission du formulaire"));
          };

          // Soumettre le formulaire
          this.newsletterForm.submit();
        });
      }

      goToBudgetStep() {
        // Depuis l'étape 2 ou 3, aller à l'étape budget (4)
        this.currentStep = 4;
        this.showStep(this.currentStep);
      }

      restartQuiz() {
        // Redémarrer le quiz depuis le début
        this.currentStep = 1;
        this.showStep(this.currentStep);

        // Réinitialiser les sélections
        this.resetSelections();
      }

      resetSelections() {
        // Remettre les premières options par défaut
        this.steps.forEach((step) => {
          const options = step.querySelectorAll(".quizz-modale__option");
          options.forEach((option, index) => {
            if (index === 0) {
              option.classList.add("quizz-modale__option--selected");
            } else {
              option.classList.remove("quizz-modale__option--selected");
            }
          });
        });

        // Vider le champ email
        if (this.emailInput) {
          this.emailInput.value = "";
        }

        // Détruire le slider s'il existe
        if (this.flickitySlider) {
          this.flickitySlider.destroy();
          this.flickitySlider = null;
        }
      }

      async loadFilteredProducts() {
        const quizData = this.getQuizData();

        this.showProductsLoader();

        try {
          const filterParams = this.buildFilterParams(quizData);
          const products = await this.fetchFilteredProducts(filterParams);

          if (products && products.length > 0) {
            this.displayProductsInSlider(products);
          } else {
            this.displayDefaultProducts();
          }
        } catch (error) {
          console.error("Erreur lors du chargement des produits:", error);
          this.displayDefaultProducts();
        } finally {
          this.hideProductsLoader();
        }
      }

      showProductsLoader() {
        if (!this.productsSlider) return;

        this.productsSlider.innerHTML = `
          <div class="quizz-modale__products-loader">
            <div class="quizz-modale__spinner"></div>
          </div>
        `;

        const collectionFilters = this.querySelector("collection-filters");
        if (collectionFilters) {
          collectionFilters.style.display = "block";
        }
      }

      hideProductsLoader() {
        const loader = this.querySelector(".quizz-modale__products-loader");
        if (loader) {
          loader.remove();
        }
      }

      buildFilterParams(quizData) {
        const params = new URLSearchParams();

        // Ajouter les filtres basés sur les réponses du quiz
        const filterMapping = {
          degustation: "filter.p.m.custom.usage_du_matcha=Dégustation",
          latte: "filter.p.m.custom.usage_du_matcha=Quotidien",
          cadeau: "filter.p.m.custom.usage_du_matcha=Cadeau",
          quotidien: "filter.p.m.custom.gamme_de_matcha=Quotidien & accessible",
          premium: "filter.p.m.custom.gamme_de_matcha=Premium & Raffiné",
          prestigieux:
            "filter.p.m.custom.gamme_de_matcha=Prestigieux & Exceptionnel",
        };

        const choice = quizData.step2or3;
        const filterParam = filterMapping[choice];

        if (filterParam) {
          const [filterKey, filterValue] = filterParam.split("=");
          params.set(filterKey, decodeURIComponent(filterValue));
        }

        if (quizData.budget) {
          // Ajouter des filtres de prix basés sur le budget
          switch (quizData.budget) {
            case "budget-25-50":
              params.append("filter.v.price.gte", "25.00");
              params.append("filter.v.price.lte", "50.00");
              break;
            case "budget-50-100":
              params.append("filter.v.price.gte", "50.00");
              params.append("filter.v.price.lte", "100.00");
              break;
            case "budget-100-200":
              params.append("filter.v.price.gte", "100.00");
              params.append("filter.v.price.lte", "200.00");
              break;
          }
        }

        return params;
      }

      async fetchFilteredProducts(filterParams) {
        const baseUrl = this.productsSourceUrl || "/collections/matcha-bio";
        const ajaxParams = new URLSearchParams(filterParams);
        ajaxParams.set("view", "ajax");
        const separator = baseUrl.includes("?") ? "&" : "?";
        const fetchUrl = `${baseUrl}${separator}${ajaxParams.toString()}`;

        const response = await fetch(fetchUrl, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const html = await response.text();

        // Parser le HTML pour extraire les produits
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const productElements = doc.querySelectorAll(
          ".grid-products > *:not(.promo-card__wrapper)",
        );

        return Array.from(productElements).slice(0, 6); // Limiter à 6 produits
      }

      displayProductsInSlider(products) {
        if (!this.productsSlider) return;

        this.productsSlider.innerHTML = "";

        if (!products || products.length === 0) {
          this.displayDefaultProducts();
          return;
        }

        // Filtrer les produits qui ressemblent aux cartes produits du thème
        const validProducts = products.filter((product) => {
          if (!product) return false;

          if (
            product.matches?.(
              "product-card, .grid-product, .grid__item, .product-card",
            )
          ) {
            return true;
          }

          return Boolean(
            product.querySelector?.(
              "product-card, .grid-product, .grid__item, .product-card",
            ),
          );
        });

        // Si aucun produit valide, afficher les produits par défaut
        if (validProducts.length === 0) {
          this.displayDefaultProducts();
          return;
        }

        validProducts.forEach((product) => {
          const slide = document.createElement("div");
          slide.className = "quizz-modale__product-slide";

          if (product.outerHTML) {
            slide.innerHTML = product.outerHTML;
          } else {
            slide.appendChild(product.cloneNode(true));
          }

          this.productsSlider.appendChild(slide);
        });

        this.initProductSlider();

        const collectionFilters = this.querySelector("collection-filters");
        if (collectionFilters) {
          collectionFilters.style.display = "block";
        }
      }

      displayDefaultProducts() {
        // Afficher des produits par défaut en cas d'erreur
        if (!this.productsSlider) return;

        this.productsSlider.innerHTML = `
          <div class="quizz-modale__no-products">
            <p>Aucun produit trouvé pour votre sélection.</p>
            <button class="quizz-modale__cta quizz-modale__cta--secondary" data-quizz-restart>
              <span class="quizz-modale__cta-text">Recommencer</span>
            </button>
          </div>
        `;

        this.querySelector(
          ".quizz-modale__no-products [data-quizz-restart]",
        ).addEventListener("click", () => {
          this.restartQuiz();
        });
      }

      initProductSlider() {
        if (!this.productsSlider || !window.Flickity) return;

        // Détruire le slider existant s'il y en a un
        if (this.flickitySlider) {
          this.flickitySlider.destroy();
        }

        // Initialiser le nouveau slider
        this.flickitySlider = new Flickity(this.productsSlider, {
          cellAlign: "left",
          contain: true,
          pageDots: true,
          prevNextButtons: false,
          wrapAround: false,
          groupCells: true,
          adaptiveHeight: true,
        });
      }

      validateCompleteButton() {
        const email = this.emailInput ? this.emailInput.value.trim() : "";
        const isValidEmail = email && this.isValidEmailFormat(email);

        if (this.completeButton) {
          if (isValidEmail) {
            this.completeButton.disabled = false;
            this.completeButton.classList.remove("btn--disabled");
          } else {
            this.completeButton.disabled = true;
            this.completeButton.classList.add("btn--disabled");
          }
        }
      }

      isValidEmailFormat(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
      }

      async completeQuiz() {
        const email = this.emailInput ? this.emailInput.value.trim() : "";

        // Vérifier que l'email est valide avant de continuer
        if (!email || !this.isValidEmailFormat(email)) {
          // Mettre le focus sur le champ email si invalide
          if (this.emailInput) {
            this.emailInput.focus();
          }
          return;
        }

        // Récupérer les choix du quiz
        const quizData = this.getQuizData();

        if (email && this.newsletterForm) {
          // Ajouter les données du quiz comme champs cachés avant soumission
          this.addQuizDataToForm(quizData);

          // Soumettre le formulaire dans un iframe pour éviter la redirection
          this.submitFormInIframe();
        }

        // Appliquer les filtres basés sur les réponses du quiz
        await this.applyQuizFilters(quizData);

        // Fermer la modale
        this.close();
      }

      submitFormInIframe() {
        // Créer un iframe caché pour la soumission
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.name = "newsletter-submit-quiz";
        document.body.appendChild(iframe);

        // Sauvegarder le target original
        const originalTarget = this.newsletterForm.target;

        // Modifier le target du formulaire vers l'iframe
        this.newsletterForm.target = "newsletter-submit-quiz";

        // Soumettre le formulaire
        this.newsletterForm.submit();

        // Nettoyer après la soumission
        setTimeout(() => {
          if (iframe.parentNode) {
            document.body.removeChild(iframe);
          }
          // Restaurer le target original
          if (originalTarget) {
            this.newsletterForm.target = originalTarget;
          } else {
            this.newsletterForm.removeAttribute("target");
          }
        }, 3000);
      }

      async applyQuizFilters(quizData, event = null) {
        // Tenter d'utiliser collection-filters
        const collectionFilters = document.querySelector("collection-filters");

        if (
          collectionFilters &&
          typeof collectionFilters.applyQuizFilters === "function"
        ) {
          event?.preventDefault?.();
          await collectionFilters.applyQuizFilters(quizData);
        } else {
          console.warn("⚠️ collection-filters introuvable, AJAX non appliqué");
        }
      }

      addQuizDataToForm(quizData) {
        // Ajouter les données du quiz comme champs cachés
        const hiddenFields = [
          { name: "contact[quiz_step1]", value: quizData.step1 || "" },
          { name: "contact[quiz_choice]", value: quizData.step2or3 || "" },
          { name: "contact[quiz_budget]", value: quizData.budget || "" },
          {
            name: "contact[quiz_completed_date]",
            value: new Date().toISOString(),
          },
        ];

        hiddenFields.forEach((field) => {
          // Vérifier si le champ n'existe pas déjà
          if (
            !this.newsletterForm.querySelector(`input[name="${field.name}"]`)
          ) {
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = field.name;
            input.value = field.value;
            this.newsletterForm.appendChild(input);
          }
        });
      }

      getQuizData() {
        const data = {
          step1: null,
          step2or3: null,
          budget: null,
          email: this.emailInput ? this.emailInput.value.trim() : null,
        };

        // Récupérer le choix de l'étape 1
        const step1 = this.querySelector('[data-step="1"]');
        const step1Option = step1.querySelector(
          ".quizz-modale__option--selected",
        );
        if (step1Option) {
          data.step1 = step1Option.dataset.option;
        }

        // Récupérer le choix de l'étape 2 ou 3
        const currentPath = data.step1 === "oui" ? 2 : 3;
        const stepElement = this.querySelector(`[data-step="${currentPath}"]`);
        const stepOption = stepElement.querySelector(
          ".quizz-modale__option--selected",
        );
        if (stepOption) {
          data.step2or3 = stepOption.dataset.option;
        }

        // Récupérer le choix de l'étape budget (4)
        const budgetStep = this.querySelector('[data-step="4"]');
        const budgetOption = budgetStep.querySelector(
          ".quizz-modale__option--selected",
        );
        if (budgetOption) {
          data.budget = budgetOption.dataset.option;
        }

        return data;
      }

      open() {
        this.trackQuizStart();
        this.details.setAttribute("open", "");
        setTimeout(() => {
          this.details.classList.add("quizz-modale--open");
        }, 10); // Petit délai pour permettre l'animation CSS
        document.body.classList.add("quizz-modale-open");
        this.currentStep = 1;
        this.showStep(1);
      }

      /**
       * Ferme la modale du quiz avec animation
       */
      close() {
        const container = this.querySelector(".quizz-modale__container");
        if (container) {
          // Attendre la fin de l'animation avant de fermer vraiment
          setTimeout(() => {
            this.details.removeAttribute("open");
            document.body.classList.remove("scroll-lock");
            this.details.classList.remove("quizz-modale--open");
          }, 10); // Correspond à la durée de transition CSS
        } else {
          this.details.removeAttribute("open");
          document.body.classList.remove("scroll-lock");
        }
      }
    },
  );
}
